module.exports = __webpack_public_path__ + "img/barcode_ex.46878b19.png";